var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.848 16.864c-.159.012-.98.061-2.814.061-1.459 0-2.494-.044-2.857-.06-5.636-.249-9.843-1.23-9.843-2.405 0-1.174 4.207-2.154 9.843-2.406v3.833c.368.026 1.424.089 2.882.089 1.75 0 2.625-.073 2.783-.088v-3.831c5.624.25 9.822 1.231 9.822 2.403 0 1.172-4.196 2.154-9.822 2.403l.005.001zm0-5.204V8.23h7.85V3H5.327v5.23h7.847v3.429C6.797 11.95 2 13.215 2 14.729c0 1.514 4.797 2.776 11.175 3.07v10.991h5.672V17.797C25.211 17.503 30 16.241 30 14.728c0-1.512-4.785-2.775-11.153-3.07l.001.002z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.aa8315bf03a80d8b67390a6fd6e5eb4c.svg";
export { ForwardRef as ReactComponent };